module.exports = __webpack_public_path__ + "img/112.5.4c337003.png";